require('js-cookie');
require('slick-carousel');
require('./init');

// Sass
require('./../sass/index.sass');